import React, { useEffect } from "react";
import { useKronicleAccount } from "../../auth";

const findCognitoIdTokenInLocalStorage = () => {
  if (typeof window === "undefined" || !window.localStorage) return null;
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.endsWith(".idToken")) {
      const token = localStorage.getItem(key);
      if (token) return token;
    }
  }
  return null;
};

export default function OAuthCallbackPage() {
  const { getAccessToken } = useKronicleAccount();

  useEffect(() => {
    // 1. Check if token is passed directly in URL params
    const urlParams = new URLSearchParams(window.location.search);
    const tokenFromUrl = urlParams.get("token");
    if (tokenFromUrl) {
      console.log("Token retrieved from URL params:", tokenFromUrl);
      localStorage.setItem("token", tokenFromUrl);
      const redirectUrl =
        sessionStorage.getItem("postLoginRedirect") ||
        localStorage.getItem("redirectAfterLogin") ||
        "/";
      localStorage.removeItem("redirectAfterLogin");
      sessionStorage.removeItem("postLoginRedirect");
      window.location.href = redirectUrl;
      return;
    }

    // 2. Poll getAccessToken() & localStorage for Cognito tokens
    let attempts = 0;
    const interval = setInterval(async () => {
      attempts++;
      try {
        let token = null;

        // Try getAccessToken() from Kronicle Account hook
        if (typeof getAccessToken === "function") {
          token = await getAccessToken();
        }

        // Fallback: search localStorage for Cognito idToken
        if (!token) {
          token = findCognitoIdTokenInLocalStorage();
        }

        console.log(`Attempt ${attempts}: Token from getAccessToken():`, token);

        if (token) {
          clearInterval(interval);
          localStorage.setItem("token", token);
          console.log("Successfully saved token to localStorage!");
          const redirectUrl =
            sessionStorage.getItem("postLoginRedirect") ||
            localStorage.getItem("redirectAfterLogin") ||
            "/";
          localStorage.removeItem("redirectAfterLogin");
          sessionStorage.removeItem("postLoginRedirect");
          window.location.href = redirectUrl;
        }
      } catch (err) {
        console.error("Error retrieving token:", err);
      }

      if (attempts >= 20) {
        console.warn("Timed out waiting for token exchange after 10 seconds");
        clearInterval(interval);
      }
    }, 500);

    return () => clearInterval(interval);
  }, [getAccessToken]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
      }}
    >
      <div style={{ marginTop: "30px", textAlign: "center" }}>
        <p style={{ fontSize: "16px", color: "#666", marginBottom: "10px" }}>
          Completing Authentication...
        </p>
        <p style={{ fontSize: "12px", color: "#999" }}>
          Please wait while we complete your authentication...
        </p>
      </div>
    </div>
  );
}
